
import {defineComponent, PropType} from "vue";
import {CmsBannerImageRestDto} from "@/api/pharma-cms-content-block/models";
import {CmsBannerImageRestDtoModel} from "@/models/api/pharma-cms-content-block/CmsBannerImageRestDtoModel";
import InputImage from "@/components/UI/InputImage.vue";
import {DpModuleEnum} from "@/api/enums/dp-module-enum";

export default defineComponent({
  name: "BannerLibraryDetailBannerItem",
  components: {InputImage},
  emits: ["bannerImageUploaded", "bannerImageDeleted"],
  props: {
    bannerImage: {
      type: Object as () => CmsBannerImageRestDto | null,
      default: null,
      required: false,
    },
    languageCode: {
      type: [String, null] as PropType<string | null>,
      required: true,
    },
    contentSizeCode: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      docType: 'BANNER_IMG' as string,
      previewUrl: null as string | null,
    };
  },
  computed: {
    DpModuleEnum() {
      return DpModuleEnum;
    },
    existingDocumentKey(): string | null {
      if (!this.hasBannerImage) {
        return null;
      }

      return this.bannerImage?.image_key ?? null;
    },
    hasBannerImage(): boolean {
      return this.bannerImage !== null && this.bannerImage.image_key !== '';
    },
    modalId(): string {
      return 'editBannerModal' + this.bannerImage?.language_code + '_' + this.bannerImage?.content_size_code;
    }
  },
  methods: {
    bannerImageUploaded(docKey: string) {
      let banner = this.bannerImage;
      if (banner === null) {
        banner = new CmsBannerImageRestDtoModel(this.contentSizeCode, docKey, this.languageCode);
      }

      this.$emit('bannerImageUploaded', banner);
    },
    imageCleared() {
      this.$emit('bannerImageDeleted');
    },
  }
});
